import formatTableJson from '@manage/config/tableComponentParams.js'
import { YNColor } from '@manage/config/StateColorEmun'
export default formatTableJson([
  {
    filed: 'account',
    label: '账号'
  },
  {
    filed: 'name',
    label: '真实姓名'
  },
  {
    filed: 'phone',
    label: '手机号'
  },
  {
    filed: 'roleName',
    label: '角色名称'
  },
  {
    filed: 'adminType',
    label: '账号类型',
    formatFn: function (_, row) {
      let dic = {
        2: '售后用户',
        3: '平台与APP'
      }
      return dic[row.adminType]
    }
  },
  {
    filed: 'state',
    label: '启用状态',
    type: 'tag',
    formatFn: function (_, row) {
      let dic = {
        Y: '启用',
        N: '停用'
      }
      return dic[row.state]
    },
    colorList: YNColor
  }
])
